import { Controller } from "@hotwired/stimulus"

// Сохраняет артикул и название сюжета результата обработки через fetch PATCH (JSON),
// без перезагрузки страницы — чтобы не перемонтировать React-воркспейс ниже. Ответ
// выводится в status-таргет (тот же приём против Turbo Drive: ответ с JSON Content-Type).
export default class extends Controller {
  static targets = ["article", "title", "status"]

  submit(event) {
    event.preventDefault()

    const url = this.element.action
    this.statusTarget.textContent = "Сохранение…"

    fetch(url, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        // Без Accept: application/json Rails выбирает format.html и делает redirect (302).
        // fetch сохраняет метод PATCH при следовании 302 → бесконечный цикл (ERR_TOO_MANY_REDIRECTS).
        "Accept": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
      },
      body: JSON.stringify({
        am_processing_result: {
          article: this.articleTarget.value,
          title: this.titleTarget.value,
        },
      }),
    })
      .then((r) => r.json())
      .then((data) => {
        this.statusTarget.textContent = data.success ? data.message : `Ошибка: ${data.error}`
      })
      .catch((e) => { this.statusTarget.textContent = `Ошибка: ${e.message}` })
  }
}
